import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Navigate } from 'react-router-dom';
import LoadingSpinner from './common/LoadingSpinner';
import hotelService from '../service/HotelService';
import staffService from '../service/StaffService';

const SmartRedirect = () => {
  const { t } = useTranslation('common');
  const [redirectTo, setRedirectTo] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const determineRedirect = async () => {
      try {
        // Check if user has a hotel assigned
        const needsOnboarding = await hotelService.needsOnboarding();
        
        if (needsOnboarding) {
          // User needs to set up their hotel
          setRedirectTo('/setup');
          return;
        }

        // Get user role to determine best landing page
        try {
          const profile = await staffService.getCurrentUserProfile();
          const userRole = profile.role;

          // Route based on role - all users go to main dashboard
          setRedirectTo('/dashboard');
        } catch (error) {
          // If can't get profile, default to dashboard
          console.error('Error getting user profile:', error);
          setRedirectTo('/dashboard');
        }

      } catch (error) {
        console.error('Error determining redirect:', error);
        // On error, try dashboard
        setRedirectTo('/dashboard');
      } finally {
        setLoading(false);
      }
    };

    determineRedirect();
  }, []);

  if (loading) {
    return <LoadingSpinner fullScreen message={t('smartRedirect.loading')} />;
  }

  if (redirectTo) {
    return <Navigate to={redirectTo} replace />;
  }

  // Fallback
  return <Navigate to="/dashboard" replace />;
};

export default SmartRedirect;